import './DialogPopup.css';
import dialogBackgroundImg from './dialog_background.png';
import titleHeaderBackgroundImg from './title_header_background.png';

/** From welcome_screen_1.svg / Figma → header background. */
export function DialogPopup() {
  return (
    <>
      <img
        className="welcome-dialog-popup__background"
        src={dialogBackgroundImg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <img
        className="welcome-dialog-popup__title-header"
        src={titleHeaderBackgroundImg}
        alt=""
        draggable={false}
        aria-hidden
      />
    </>
  );
}
